module.exports = __webpack_public_path__ + "img/home-bg1-en.a5e239b6.png";